import { render, staticRenderFns } from "./SearchDestinatario.vue?vue&type=template&id=632ac351"
import script from "./SearchDestinatario.vue?vue&type=script&lang=ts"
export * from "./SearchDestinatario.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports